import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import AutoComplete  from 'material-ui/AutoComplete';
import MenuItem  from 'material-ui/MenuItem';
import { DeleteBtn } from 'components/lib/buttons/IconButtons';
import styles from 'styles/components/lib/formElements/controlledSelect.css';
import DOMUtils from 'utils/DOMUtils.js';

export default class ControlledSelect extends Component {
  constructor (props) {
    super(props);
    this.state = {
      errorText: null,
      menuHeight: 0,
      openMenu: this.props.openMenu,
      selectedItemName: this.props.selectedItemName || '',
      nameWidth: 0
    }
    this.handleClickInput = this.handleClickInput.bind(this);
    this.handleClickOut = this.handleClickOut.bind(this);
    this.handleFilter =this.handleFilter.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputDelete = this.handleInputDelete.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.setError = this.setError.bind(this);
    this.setItem = this.setItem.bind(this);
    this.setPrev = this.setPrev.bind(this);
    this.toggleMenu= this.toggleMenu.bind(this);
    this.getNameWidth = this.getNameWidth.bind(this);
  }
  componentDidMount() {
    window.addEventListener('click', this.handleClickOut );
    window.addEventListener('touchstart', this.handleClickOut );
    window.addEventListener('resize', this.getNameWidth );
    this.getMenuHeight();
    this.getNameWidth();
  }
  componentWillReceiveProps(nProps) {
    if (nProps.clientid !== this.props.clientId) {
      this.getAutocompleteData();
    }
    if (!this.state.selectedItemName) {
      this.setState({
        selectedItemName: nProps.selectedItemName
      });
    }
    if (this.props.seriesComparison && !nProps.selectedItemName) {
      this.setState({
        selectedItemName: null
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.handleClickOut );
    window.removeEventListener('touchstart', this.handleClickOut );
    window.removeEventListener('resize', this.getNameWidth );
  }
  getAutocompleteData = () => {
    let { items, selectedIds } = this.props;
    let data = [];
    let currentPerformances = [];
    let pastPerformances = [];
    if (items) {
      items.sort((a, b) =>
        (a.hasFuturePerformances === b.hasFuturePerformances)
          ? 0
          : a.hasFuturePerformances
            ? -1
            : 1
      );
      for (var i = 0; i < items.length; i++){
        if(i === 0) {
          if(items[i].hasFuturePerformances === true) {
            currentPerformances = items.slice()
            pastPerformances = [];
          } else {
            pastPerformances = items.slice()
            currentPerformances = [];
          }
        }
        if(items[i].hasFuturePerformances === false){
          currentPerformances = items.slice(0, i);
          pastPerformances = items.slice(i);
          break;
        }
      }
      currentPerformances.sort((a, b) => (
        a.productionName.toLowerCase() > b.productionName.toLowerCase()) ? 1 : -1
      );
      pastPerformances.sort((a, b) => (
        a.productionName.toLowerCase() > b.productionName.toLowerCase()) ? 1 : -1
      );
      if (Object.keys(currentPerformances).length > 0) {
        data.push({
          text: '',
          value: (
            <MenuItem
            disabled={true}
            className={styles.currentTitle}
            primaryText='Current Series' />
          )
        })
        Object.keys( currentPerformances ).forEach( key => {
          let item = currentPerformances[key];
          if(this.props.seriesComparison) {
            if(selectedIds.indexOf(item.productionId) === -1 && item.hasTransactions === true) {
              data.push(
                { text: item.productionName,
                  id:item.productionId,
                  value: (
                    <MenuItem
                    key={key}
                    className={styles.menuItem}
                    primaryText={item.productionName}
                    value={item.productionId} />
                  )
                }
              );
            }
          } else {
            data.push(
              { text: item.productionName,
                id:item.productionId,
                value: (
                  <MenuItem
                  key={key}
                  className={styles.menuItem}
                  primaryText={item.productionName}
                  value={item.productionId} />
                )
              }
            );
          }
        });
      }
      if (Object.keys(pastPerformances).length > 0) {
        data.push({
          text: '',
          value: (
            <MenuItem
            disabled={true}
            className={styles.pastTitle}
            primaryText='Past Series' />
          )
        })
        Object.keys( pastPerformances ).forEach( key => {
          let item = pastPerformances[key];
          if(this.props.seriesComparison) {
            if(selectedIds.indexOf(item.productionId) === -1 && item.hasTransactions === true) {
              data.push(
                { text: item.productionName,
                  id:item.productionId,
                  value: (
                    <MenuItem
                    key={key}
                    className={styles.pastPerformance}
                    primaryText={item.productionName}
                    alt={item.productionName}
                    value={item.productionId} />
                  )
                }
              );
            }
          } else {
            data.push(
              { text: item.productionName,
                id:item.productionId,
                value: (
                  <MenuItem
                  key={key}
                  className={styles.pastPerformance}
                  primaryText={item.productionName}
                  alt={item.productionName}
                  value={item.productionId} />
                )
              }
            );
          }
        });
      }
    }

    return data;
  }
  getMenuHeight = () => {
    let { isTouchDevice } = this.context.media;
    let vh = DOMUtils.getWindowHeight();
    let menuHeight = isTouchDevice ? 150 : vh * 0.4;
    if (!this.props.isDialog ) {
      let ele = this.refs.ot_autocomplete;
      if (ele) {
        let top = DOMUtils.offset(ele).top;
        let h = DOMUtils.outerHeight(ele);
        menuHeight = (vh - top - h - 200);
      }
    }
    this.setState({ menuHeight});
  }
  getProduction= (request) => {
    let { items } = this.props;
    let filteredItems = items.filter( production  => {
      return production.productionName.toLowerCase() === request;
    });
    return filteredItems[0];
  }
  getNameWidth = () => {
    let width = ReactDOM.findDOMNode(this.refs.autoComplete).getBoundingClientRect().width
    this.setState({
      nameWidth: width
    });
  }
  handleClickInput(e) {
    // console.log('CLICK input');
    e.stopPropagation();
  }
  handleClickOut() {
    // console.log('OUT');
    if (this.state.openMenu) {
      let { selectedItemName } = this.state;
      if ( !selectedItemName ||
        selectedItemName !== this.props.selectedItemName) {
        this.setPrev();
      }
      this.toggleMenu(false);
    }
  }
  handleFilter(searchText, key) {
    let { selectedItemName } = this.props;
    let currentItem = key ? key.toLowerCase() : null;
    if (!searchText ) return true;

    let request = (typeof searchText === "object") ? searchText.productionName : searchText;
    if (typeof selectedItemName === 'string' || this.props.isDialog) {
      if ( request && currentItem &&
        ( !selectedItemName || // when no props
          ( selectedItemName &&  // when input value has changed
            selectedItemName.toLowerCase() !== request.toLowerCase() ))) {

              return currentItem.indexOf(request.toLowerCase()) !== -1;
            } else {  return true; }
    }
  }
  handleInputChange(selectedItemName) {
    // Controls Input Editing
    if (selectedItemName !== this.state.selectedItemName) {
      this.setState({ selectedItemName });
    }
  }
  handleInputDelete(e) {
    e.stopPropagation();
    // console.log('DELETE', !!this.state.openMenu, !!this.state.selectedItemName );
    if (this.state.openMenu && this.state.selectedItemName) {
      this.setState({ selectedItemName: ''}, () => {
        this.handleFilter();
      });
    }
    this.refs.autoComplete.focus();
  }
  handleKeyDown() {
    // helps select first option
    let node = this.refs.autoComplete;
    if (node.refs.menu) {
      node.refs.menu.setState({
        isKeyboardFocused: true,
      });
    }
  }
  handleNewRequest(chosenRequest: string, index: number) {
    // console.log('HANDLENEWREQUEST', chosenRequest, index);
    let { selectedItemName } = this.props;
    let request = (typeof chosenRequest === 'object')
      ? chosenRequest.text.toLowerCase()
      : chosenRequest.toLowerCase();

    if (selectedItemName &&
        request === selectedItemName.toLowerCase() ) {
      // If same -> restores capitalization from props and exits edit
      // console.log('IS SAME -> RESTORE');
      this.setPrev(false);

    } else if (this.props.items) {
      let production = (typeof chosenRequest === 'object')
        ? { productionName: chosenRequest.text,
            productionId: chosenRequest.id }
        : this.getProduction(request);
      if (production) this.setItem(production);
      else this.setError();
    }
  }
  setError() {
    this.refs.autoComplete.blur();
    this.setState({
      errorText: this.props.error }, () => {
        setTimeout(() => { this.setPrev(true); }, 1800);
    })
  }
  setItem(production) {
    // console.log('SETITEM');
    this.setState({
      selectedItemName: production.productionName
    }, () => {
      this.props.onChange(production.productionId);
      this.toggleMenu(false);
    });
  }
  setPrev(openMenu) {
    // console.log('SETPREV', openMenu);
    this.setState({
      errorText: null,
      selectedItemName: this.props.selectedItemName
    })

    if (openMenu !== undefined) this.toggleMenu(openMenu);
    else if (this.props.handleMenu) {
      this.props.handleMenu(false);
      this.refs.autoComplete.blur();
    }
  }
  toggleMenu(value) {
    if(value) this.refs.autoComplete.focus();
    else  this.refs.autoComplete.blur();
        // console.log('TOGGLE', value);
    this.setState({openMenu: value});

    if (this.props.handleMenu) this.props.handleMenu(value);
  }
  render() {
    let { openMenu } = this.state;
    let height = '80px'
    let underlineStyle = {display: 'unset'};
    if (this.props.seriesComparison) {
      height = '70px'
    }
    return (
      <div ref="ot_autocomplete" className={styles.controlledSelect} style={this.props.style}>
        <AutoComplete ref="autoComplete"
          dataSource={this.getAutocompleteData()}
          className="printHidden"
          errorText={this.state.errorText}
          errorStyle={{marginTop:'-10px'}}
          filter={this.handleFilter}
          floatingLabelText={this.props.isDialog ? this.props.label : ''}
          hintText={"Select Series"}
          inputStyle={openMenu
            ? {position: 'relative', height: height, paddingRight: '40px', width: '350px'}
            : {position: 'relative', height: height, width: `${this.state.nameWidth}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
          menuProps={{maxHeight: this.props.seriesComparison ? '400px' : this.state.menuHeight}}
          menuStyle={{padding: '0px'}}
          name="autocomplete"
          onClick={this.handleClickInput}
          onTouchStart={this.handleClickInput}
          onKeyDown={this.handleKeyDown}
          onNewRequest={this.handleNewRequest}
          onUpdateInput={this.handleInputChange}
          open={openMenu}
          openOnFocus={true}
          searchText={this.state.selectedItemName || ''}
          style={{width: '100%'}}
          underlineStyle={this.props.seriesComparison
            ? {}
            : openMenu ? underlineStyle : {display: 'none'}
          }
          listStyle={{paddingBottom: '0px', width: '350px'}}
          textFieldStyle={openMenu
            ? {height: height, paddingRight: '40px', width: '350px'}
            : {height: height, width: this.props.seriesComparison ? '100%' : '50vw'}}  />
        { openMenu &&
          <DeleteBtn
            onTouchStart={this.handleInputDelete}
            onClick={this.handleInputDelete}
            outerShape={true}
            style={{position: 'absolute', top: '30px', left: '315px', zIndex: '10'}} />
        }
      </div>
    );
  }
}

ControlledSelect.defaultProps = {
  seriesAutoCompleteText: "-"
};

ControlledSelect.propTypes = {
  error: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.object ]),
  items: PropTypes.array,
  label: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.object ]),
  onChange: PropTypes.func,
  selectedItemName: PropTypes.string,
  isDialog: PropTypes.bool,
  openMenu: PropTypes.bool
};

ControlledSelect.contextTypes = {
  media: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/scripts/components/lib/formElements/ControlledSelect.js